import React, { useContext, useState, useRef } from 'react';
import { callIfFunction } from './utils/FunctionUtils';
import { deleteCurrentLaunchTypeCookie } from './components/AlmeLaunchPoint/LaunchTypeCookie';
import { deleteCurrentRequiresQualtricsCookie } from './utils/RequiresQualtricsCookie';
import { deleteCurrentHadLiveChatCookie } from './components/LiveChat/AlmeLiveChatSurvey/HadLiveChatQualtricsCookie';
const DefaultChatPosition = "BottomRight";
const DefaultChatIconPosition = "TopRight";
const IVAChatStatusContext = React.createContext({
    isAvailable: false,
    isOpen: false,
    isActive: false,
    chatPosition: DefaultChatPosition,
    chatIconPosition: DefaultChatIconPosition
});
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {
    //intentionally using empty function
};
const IVASetChatStatusContext = React.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    initChatStatus(ivaChatStatus) {
        //intentionally using empty function
    },
    openChat: noop,
    closeChat: noop,
    minimizeChat: noop,
    pointOfNeedChat: noop,
    positionChat: {
        topRight: noop,
        topLeft: noop,
        bottomRight: noop,
        bottomLeft: noop,
    },
    positionChatIcon: {
        topRight: noop,
        topLeft: noop,
        bottomRight: noop,
        bottomLeft: noop,
    },
    setInternalMinimizeChatHook(hook) {
        //intentionally using empty function
    },
    initiatePointOfNeedChatHook(hook) {
        //intentionally using empty function
    },
});
export const useIVAChatStatus = () => {
    return useContext(IVAChatStatusContext);
};
export const useIVASetChatStatus = () => {
    return useContext(IVASetChatStatusContext);
};
export const IVAChatStatusProvider = ({ children, chatPosition, chatIconPosition }) => {
    const [chatStatus, setChatStatus] = useState({
        isAvailable: false,
        isOpen: false,
        isActive: false,
        chatPosition: chatPosition || DefaultChatPosition,
        chatIconPosition: chatIconPosition || DefaultChatIconPosition
    });
    const onMinimizeChatHook = useRef();
    const onPointOfNeedChatHook = useRef();
    const ivaSetChatStatus = {
        initChatStatus: setChatStatus,
        openChat() { setChatStatus(Object.assign(Object.assign({}, chatStatus), { isOpen: true, isActive: true })); },
        closeChat() {
            /* eslint-disable @typescript-eslint/no-unsafe-call */
            setChatStatus(Object.assign(Object.assign({}, chatStatus), { isOpen: false, isActive: false }));
            deleteCurrentLaunchTypeCookie();
            deleteCurrentRequiresQualtricsCookie();
            deleteCurrentHadLiveChatCookie();
        },
        setInternalMinimizeChatHook(hook) {
            onMinimizeChatHook.current = hook;
        },
        minimizeChat() {
            callIfFunction(onMinimizeChatHook.current);
            setChatStatus(Object.assign(Object.assign({}, chatStatus), { isOpen: false }));
        },
        initiatePointOfNeedChatHook(hook) {
            onPointOfNeedChatHook.current = hook;
        },
        pointOfNeedChat(launchPoint, currentEnterpriseId) {
            setChatStatus(Object.assign(Object.assign({}, chatStatus), { launchPointName: launchPoint, ponEnterpriseId: currentEnterpriseId }));
            setTimeout(() => {
                callIfFunction(onPointOfNeedChatHook.current);
            }, 100);
        },
        positionChat: {
            topRight() { setChatStatus(Object.assign(Object.assign({}, chatStatus), { chatPosition: "TopRight" })); },
            topLeft() { setChatStatus(Object.assign(Object.assign({}, chatStatus), { chatPosition: "TopLeft" })); },
            bottomRight() { setChatStatus(Object.assign(Object.assign({}, chatStatus), { chatPosition: "BottomRight" })); },
            bottomLeft() { setChatStatus(Object.assign(Object.assign({}, chatStatus), { chatPosition: "BottomLeft" })); },
        },
        positionChatIcon: {
            topRight() { setChatStatus(Object.assign(Object.assign({}, chatStatus), { chatIconPosition: "TopRight" })); },
            topLeft() { setChatStatus(Object.assign(Object.assign({}, chatStatus), { chatIconPosition: "TopLeft" })); },
            bottomRight() { setChatStatus(Object.assign(Object.assign({}, chatStatus), { chatIconPosition: "BottomRight" })); },
            bottomLeft() { setChatStatus(Object.assign(Object.assign({}, chatStatus), { chatIconPosition: "BottomLeft" })); },
        },
    };
    return (React.createElement(IVAChatStatusContext.Provider, { value: chatStatus },
        React.createElement(IVASetChatStatusContext.Provider, { value: ivaSetChatStatus },
            React.createElement(React.Fragment, null, children))));
};
